<app-agricola-navbar></app-agricola-navbar>

<div class="dashboard-container">
  <div class="dashboard-content">
    <!-- Greeting Section -->
    <div class="greeting-section">
      <h1 class="greeting">Hola {{ userName$ | async }}</h1>
      <h2 class="greeting-question">¿Qué deseas hacer hoy?</h2>
    </div>

    <!-- Feature Cards -->
    <div class="cards-container">
      <button class="card pcard" type="button" *ngFor="let card of cards" (click)="onCardClick(card)">
        <div class="card-image-container">
          <img [src]="card.image" [alt]="card.title" class="card-image" />
          <div class="new-badge" *ngIf="card.isNew">
            <i class="fas fa-paper-plane" aria-hidden="true"></i>
            <span>Nuevo</span>
          </div>
        </div>
        <div class="card-content">
          <h3 class="card-title">{{ card.title }}</h3>
          <p class="card-description">{{ card.description }}</p>
          <span class="card-link">Ver más</span>
        </div>
      </button>
    </div>
  </div>
</div>
